const TRIP_LINE_WIDTH_EXPRESSION = [
  'interpolate',
  ['exponential', 1.5],
  ['zoom'],
  3,
  [
    'case',
    ['==', ['feature-state', 'isHidden'], true],
    1.8,
    ['==', ['feature-state', 'isHidden'], false],
    2.4,
    1.8,
  ],
  18,
  [
    'case',
    ['==', ['feature-state', 'isHidden'], true],
    14,
    ['==', ['feature-state', 'isHidden'], false],
    24,
    14,
  ],
];
const TRIP_LINE_OPACITY_EXPRESSION = [
  'case',
  ['to-boolean', ['feature-state', 'isHidden']],
  0.33,
  1,
];

export const tripLine = Object.freeze({
  id: 'trip-line',
  type: 'line',
  layout: {
    'line-cap': 'round',
  },
  paint: {
    'line-color': '#5742e0',
    'line-width': TRIP_LINE_WIDTH_EXPRESSION,
    'line-opacity': TRIP_LINE_OPACITY_EXPRESSION,
  },
});

export const tripDirectionArrows = Object.freeze({
  id: 'trip-direction-arrows',
  type: 'symbol',
  layout: {
    'symbol-placement': 'line',
    'symbol-spacing': 50,
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-image': 'trip-direction-arrow',
    'icon-size': 1,
  },
  paint: {
    'icon-opacity': 1,
  },
});

export const stopsCircle = Object.freeze({
  id: 'trip-stops-circle',
  type: 'circle',
  paint: {
    'circle-radius': ['interpolate', ['linear'], ['zoom'], 12, 10, 20, 30],
    'circle-color': [
      'case',
      ['to-boolean', ['get', 'color']],
      ['get', 'color'],
      '#ffffff',
    ],
    'circle-opacity': [
      'case',
      ['to-boolean', ['feature-state', 'isHidden']],
      0.33,
      1,
    ],
    'circle-stroke-color': [
      'case',
      ['to-boolean', ['get', 'strokeColor']],
      ['get', 'strokeColor'],
      '#e0e0e0',
    ],
    'circle-stroke-width': 1,
  },
});

export const stopsLabel = Object.freeze({
  id: 'trip-stops-label',
  type: 'symbol',
  layout: {
    'text-allow-overlap': true,
    'text-field': '{label}',
    'text-size': 14,
  },
  paint: {
    'text-color': [
      'case',
      ['to-boolean', ['get', 'textColor']],
      ['get', 'textColor'],
      '#000000',
    ],
    'text-opacity': [
      'case',
      ['to-boolean', ['feature-state', 'isHidden']],
      0.33,
      1,
    ],
  },
});
